import { CATALOGO_DE_HISTORIAS, fraseDaHistoria, ROTULO_DO_TIPO, tipoDoCodigo } from './catalogo';
import type { ConferenciaDaHistoria } from './contexto';

/**
 * O que o modo histórias leva para fora da tela (manual p.47 e p.48): o link de
 * uma história e o roteiro de teste da tela.
 */

const ANCORA = /^#historia=([A-Z]{3}-[A-Z]{3}-[0-9]{2})$/;

/** O link que abre a tela já com o cartão da história aberto ("Copiar link", p.47). */
export function linkDaHistoria(origem: string, caminho: string, busca: string, codigo: string): string {
  return `${origem}${caminho}${busca}#historia=${codigo}`;
}

/** O código da história no fim do endereço, ou nulo. */
export function historiaDaAncora(ancora: string): string | null {
  return ANCORA.exec(ancora)?.[1] ?? null;
}

/**
 * "Exportar roteiro de teste" (p.48): para cada elemento da tela, na ordem dos
 * marcadores, o que conferir — os critérios de aceite da história — e a última
 * conferência. Texto puro, para colar num chamado ou imprimir.
 */
export function roteiroDeTeste(
  tela: string,
  naTela: readonly string[],
  conferencias: ReadonlyMap<string, ConferenciaDaHistoria>,
  geradoEm: string,
): string {
  const linhas = [`Roteiro de teste · ${tela}`, `Gerado em ${geradoEm} · ${String(naTela.length)} elementos na tela`, ''];
  naTela.forEach((codigo, i) => {
    const h = CATALOGO_DE_HISTORIAS.get(codigo);
    const tipo = tipoDoCodigo(codigo);
    const c = conferencias.get(codigo);
    linhas.push(`${String(i + 1)}. ${codigo} · ${tipo ? ROTULO_DO_TIPO[tipo] : 'Elemento'} · ${h?.titulo ?? 'sem história escrita'}`);
    if (h) {
      linhas.push(`   ${fraseDaHistoria(h)}`);
      h.criterios.forEach((criterio) => linhas.push(`   [ ] ${criterio}`));
    } else {
      linhas.push('   [ ] Escrever a história deste elemento antes de conferir.');
    }
    linhas.push(`   Última conferência: ${c ? `${c.situacao === 'conferida' ? 'conferida' : 'divergente'}${c.quem ? `, por ${c.quem}` : ''}` : 'nenhuma'}`);
    linhas.push('');
  });
  return linhas.join('\n');
}
